module.exports = __webpack_public_path__ + "static/img/tuimo.9c2fbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/tuimo.png
// module id = kZtS
// module chunks = 0